import { render, staticRenderFns } from "./addSoToWave.vue?vue&type=template&id=5d853ce2&"
import script from "./addSoToWave.vue?vue&type=script&lang=js&"
export * from "./addSoToWave.vue?vue&type=script&lang=js&"
import style0 from "./addSoToWave.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports